export const ROLE_ADMIN = 'admin'
export const ROLE_CERTIFICATION_MANAGER = 'certification manager'
export const ROLE_CONTENT_CREATOR = 'content creator'

export const CONTENT_CREATOR_ROLES = [ROLE_CONTENT_CREATOR, ROLE_ADMIN]
export const CERTIFICATION_ROLES = [ROLE_CERTIFICATION_MANAGER, ROLE_ADMIN]
